module.exports = {
      id: "video-play-btn-usage",
      viewBox: "0 0 82 82",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#video-play-btn",
      toString: function () {
        return this.url;
      }
    }